import React from 'react';

import {
    ConstraintType,
    DataTypeConstraintDto,
    StringLengthRangeConstraintDataDto
} from '../../../../../../common/apis/datatype/DataTypeConstraintDto';
import {CoreDataType} from "../../../../../../common/apis/datatype/DataTypeDefinitionDto";
import {DataTypeTranslationKey} from "../../DataTypeTranslationKey";
import {StringLengthRangeConstraintPluginForm} from "./StringLengthRangeConstraintPluginForm";
import {ConstraintDataPlugin, ConstraintPluginProps} from "../ConstraintDataPlugin";
import {ConstraintValueValidationPlugin} from "../ConstraintValueValidationPlugin";
import {StereotypesTranslationKey} from "../../../stereotypes/StereotypesTranslationKey";
import {CommonTranslationKey} from "../../../CommonTranslationKey";
import {TranslationFunction} from "../../../../../../store/localization/TranslMessasge";


export class StringLengthRangeConstraintPlugin implements ConstraintDataPlugin<StringLengthRangeConstraintDataDto>, ConstraintValueValidationPlugin {
    readonly type = ConstraintType.STRING_LENGTH_RANGE;

    getSupportedDataTypes(): CoreDataType[] {
        return [
            CoreDataType.STRING
        ];
    }

    getInitialData(): StringLengthRangeConstraintDataDto {
        return {
            type: ConstraintType.STRING_LENGTH_RANGE,
            min: 0,
            max: undefined,
        };
    }

    render(props: ConstraintPluginProps<StringLengthRangeConstraintDataDto>): React.ReactElement {
        return <StringLengthRangeConstraintPluginForm {...props} />;
    }


    validate(data: StringLengthRangeConstraintDataDto, coreDataType: CoreDataType): Record<string, string> {
        const errors: Record<string, string> = {};
        const {min, max} = data;

        if (min === null || min === undefined) {
            errors.min = CommonTranslationKey.FILL_OUT_THIS_FIELD
            return errors;
        } else {
            if (min < 0) {
                errors.min = DataTypeTranslationKey.MIN_LENGTH_MUST_BE_GREATER_THAN_OR_EQUAL_TO_ZERO;
                return errors;
            }
            if (max !== null && max !== undefined) {
                if (max < min) {
                    errors.min = DataTypeTranslationKey.MIN_VALUE_MUST_BE_LESS_THAN_OR_EQUAL_TO_MAX;
                    return errors;
                }
                if (min === 0 && max === 0) {
                    errors.min = DataTypeTranslationKey.STRING_LENGTH_MUST_NOT_BE_ZERO;
                    return errors;
                }
            }
        }

        return errors;
    }


    validateValue(value: any, attributeId: string, constraint: DataTypeConstraintDto, t: TranslationFunction): Record<string, string> {

        const constraintData = constraint.constraintData as StringLengthRangeConstraintDataDto;
        const {min, max} = constraintData;


        if (value === null || value === undefined) {
            return {
                [attributeId]: t(CommonTranslationKey.FILL_OUT_THIS_FIELD)
            };
        }

        if (min != null && value.length < min) {
            return this.errorResult(t(StereotypesTranslationKey.VALUE_IS_BELLOW_ALLOWED_LIMIT), attributeId);
        }

        if (max != null && value.length > max) {
            return this.errorResult(t(StereotypesTranslationKey.VALUE_IS_ABOVE_ALLOWED_LIMIT), attributeId);
        }

        return {}

    }


    private errorResult(error: string, attributeId: string) {
        return {
            [attributeId]: error
        };
    }

    getConstraintExpression(data: StringLengthRangeConstraintDataDto, t: TranslationFunction): string {
        const {min, max} = data;

        if (min === undefined && max === undefined) return "";

        const left = min !== null && min !== undefined ? min.toFixed(0) : "0";
        const right = max !== null && max !== undefined ? max.toFixed(0) : "∞";

        return `[${left}-${right}] ${t(DataTypeTranslationKey.CHARACTERS)}`;
    }


}
